import type { Document } from '@contentful/rich-text-types';

export const accordionsSectionContentType = 'questionsContainer';

export interface ParseAccordionsSectionEmbeddedEntryArgs {
	fields: unknown;
	renderRichText: (document: Document) => string;
}

export function parseAccordionsSectionEmbeddedEntry(
	args: ParseAccordionsSectionEmbeddedEntryArgs,
): string | undefined {
	const { fields, renderRichText } = args;
	const sectionFields = fields as
		| {
				title?: string;
				questions?: Array<{
					fields?: { questionTitleExternal?: string; anchorId?: string; answer?: Document };
				}>;
		  }
		| undefined;
	if (!sectionFields?.title || !Array.isArray(sectionFields.questions)) {
		return undefined;
	}

	const accordions = sectionFields.questions.flatMap((entry) => {
		const { questionTitleExternal, anchorId, answer } = entry?.fields ?? {};
		return questionTitleExternal && answer?.nodeType === 'document'
			? [{ title: questionTitleExternal, anchorId, content: renderRichText(answer) }]
			: [];
	});
	const props = { heading: sectionFields.title, accordions };
	return `<div data-embedded-questions-container="${encodeURIComponent(JSON.stringify(props))}"></div>`;
}
